module.exports = __webpack_public_path__ + "static/media/DSC_0777.a5a43c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0777.jpg
// module id = 701
// module chunks = 0